import React from 'react';
import PropTypes from 'prop-types';
import { isBrowser } from '../../utils/is-browser.js';

import {
  Card,
  LinkStyled,
  CardText,
  CardImage,
  ImageWrapper,
  TextWrapper,
  LinkWrapper,
} from './styles';

/**
 * Displays a card link created from title, image, link, and link text
 * For use with card link assembly component
 */
const CardLink = ({
  title,
  image,
  cardLink,
  linkText,
  assemblyAnalyticsData,
  cardPosition,
}) => {
  if (!image) return null;

  const analyticsData = {
    ...assemblyAnalyticsData,
    cardTitle: title,
    linkDestination: cardLink.external ? cardLink.URL : cardLink.slug,
    buttonCTA: linkText,
    buttonLocation: isBrowser ? window.location.pathname : null,
    cardPosition,
    cardSection: isBrowser ? window.location.pathname.split('/')[1] : null,
  };

  return (
    <Card>
      <ImageWrapper>
        <CardImage
          mobileW={265}
          mobileH={147}
          desktopW={662}
          desktopH={370}
          fit="fill"
          focusArea="center"
          image={image}
          presentational
        />
      </ImageWrapper>
      <TextWrapper>
        <CardText>{title}</CardText>
        <LinkWrapper>
          <LinkStyled link={cardLink} analyticsData={analyticsData}>
            {linkText}
          </LinkStyled>
        </LinkWrapper>
      </TextWrapper>
    </Card>
  );
};

CardLink.propTypes = {
  image: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  cardLink: PropTypes.object.isRequired,
  assemblyAnalyticsData: PropTypes.object.isRequired,
  linkText: PropTypes.string.isRequired,
  cardPosition: PropTypes.number.isRequired,
};

export default CardLink;
